import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class OwnerService {
  private apiUrl = '/owners';
  private apiPlayUrl = '/play/owners';
  private apiSpringUrl = '/spring/owners';

  constructor(private http: HttpService) { }

  get(): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    return this.http.get(url);
  }

  post(
    ownerCd: string,
    ownerTx: string,
    ownerfullname1Tx: string,
    ownerfullname2Tx: string,
    owneraccCd: string,
    ownerpostalCd: string,
    owneraddress1Tx: string,
    owneraddress2Tx: string,
    owneraddress3Tx: string,
    ownertelTx: string,
    yamatobasenoCd: string,
    whCd: string,
    salesofficeId: number,
    bookendNr: number,
    invstockfreqNr: number,
    // delimemodelidateNr: number,
    // delimemomemodetNr: number,
    // delimemoordernoNr: number,
    // delimemoitemNr: number,
    // delidateFl: number,
    // itemnameFl: number,
    // memodetFl: number,
    // memodetinveFl: number,
    delipriceFl: number,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") +'/spring'+ this.apiUrl;
    const jsonInput = {
      ownerCd: ownerCd,
      ownerTx: ownerTx,
      ownerfullname1Tx: ownerfullname1Tx,
      ownerfullname2Tx: ownerfullname2Tx,
      owneraccCd: owneraccCd,
      ownerpostalCd: ownerpostalCd,
      owneraddress1Tx: owneraddress1Tx,
      owneraddress2Tx: owneraddress2Tx,
      owneraddress3Tx: owneraddress3Tx,
      ownertelTx: ownertelTx,
      yamatobasenoCd: yamatobasenoCd,
      whCd: whCd,
      salesofficeId: salesofficeId,
      bookendNr: bookendNr,
      invstockfreqNr: invstockfreqNr,
      // delimemodelidateNr: delimemodelidateNr,
      // delimemomemodetNr: delimemomemodetNr,
      // delimemoordernoNr: delimemoordernoNr,
      // delimemoitemNr: delimemoitemNr,
      // delidateFl: delidateFl,
      // itemnameFl: itemnameFl,
      // memodetFl: memodetFl,
      // memodetinveFl: memodetinveFl,
      delipriceFl: delipriceFl,
      updprogramCd: updprogramCd
    };
    console.log('■jsonInput');
    console.log(jsonInput);
    return this.http.post(url, jsonInput);
  }

  getNeedStockDt(ownerId: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/needstockdt/${ownerId}`;
    const jsonInput = {ownerId: ownerId}
    return this.http.post(url,jsonInput);
  }

  put(
    ownerId: number,
    ownerCd: string,
    ownerTx: string,
    ownerfullname1Tx: string,
    ownerfullname2Tx: string,
    owneraccCd: string,
    ownerpostalCd: string,
    owneraddress1Tx: string,
    owneraddress2Tx: string,
    owneraddress3Tx: string,
    ownertelTx: string,
    yamatobasenoCd: string,
    whCd: string,
    salesofficeId: number,
    bookendNr: number,
    invstockfreqNr: number,
    // delimemodelidateNr: number,
    // delimemomemodetNr: number,
    // delimemoordernoNr: number,
    // delimemoitemNr: number,
    // delidateFl: number,
    // itemnameFl: number,
    // memodetFl: number,
    // memodetinveFl: number,
    delipriceFl: number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") +'/spring'+ this.apiUrl}/${ownerId}`;
    const jsonInput = {
      ownerId: ownerId,
      ownerCd: ownerCd,
      ownerTx: ownerTx,
      ownerfullname1Tx: ownerfullname1Tx,
      ownerfullname2Tx: ownerfullname2Tx,
      owneraccCd: owneraccCd,
      ownerpostalCd: ownerpostalCd,
      owneraddress1Tx: owneraddress1Tx,
      owneraddress2Tx: owneraddress2Tx,
      owneraddress3Tx: owneraddress3Tx,
      ownertelTx: ownertelTx,
      yamatobasenoCd: yamatobasenoCd,
      whCd: whCd,
      salesofficeId: salesofficeId,
      bookendNr: bookendNr,
      invstockfreqNr: invstockfreqNr,
      // delimemodelidateNr: delimemodelidateNr,
      // delimemomemodetNr: delimemomemodetNr,
      // delimemoordernoNr: delimemoordernoNr,
      // delimemoitemNr: delimemoitemNr,
      // delidateFl: delidateFl,
      // itemnameFl: itemnameFl,
      // memodetFl: memodetFl,
      // memodetinveFl: memodetinveFl,
      delipriceFl: delipriceFl,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

  delete(
    ownerId: number
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") +'/spring'+ this.apiUrl}/${ownerId}`;
    return this.http.delete(url);
  }

}

/** 荷主 */
export type Owner = {
  companyId: number,
  logicalwhId: number,
  ownerId:number,
  ownerCd:string,
  ownerTx:string,
  ownerfullname1Tx:string,
  ownerfullname2Tx:string,
  ownerdisplayTx:string,
  owneraccCd:string,
  ownerpostalCd:string,
  owneraddress1Tx:string,
  owneraddress2Tx:string,
  owneraddress3Tx:string,
  ownertelTx:string,
  invstockfreqNr:number,
  delimemodelidateNr:number,
  delimemomemodetNr:number,
  delimemoordernoNr:number,
  delimemoitemNr:number,
  yamatobasenoCd:string,
  delidateFl:number,
  itemnameFl:number,
  memodetFl:number,
  memodetinveFl:number,
  whCd:string,
  salesofficeId:number,
  updDt:string,
  upduserId:number,
  upduserTx:string,
  addDt:string,
  adduserId:number,
  adduserTx:string,
  updprogramCd:string,
  updcounterNr:number,
  strecordId:number,
};



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/owner/owner.service.ts